import React from 'react';
import ComplexParcelDetail from './ComplexParcelDetail';
import { Parcel } from '../types';

interface ParcelDetailsProps {
  parcel: Parcel | undefined;
}

const ParcelDetails: React.FC<ParcelDetailsProps> = ({ parcel }) => {
  if (!parcel) { return null; }
  const { attributes } = parcel;
  const parcelArea = attributes.Shape_Area
  return (
    <dl className="dl-horizontal">
      <dt>Owner Name</dt>
      <dd>{attributes.OwnerName}</dd>
      <dt>PIN</dt>
      <dd>{attributes.PIN}</dd>
      <dt>TMS</dt>
      <dd>{attributes.TMS}</dd>
      <dt>Lot</dt>
      <dd>{attributes.LOT}</dd>
      <dt>Parcel Type</dt>
      <dd>{attributes.PARCELTYPE}</dd>
      <dt>Zoning Code</dt>
      <dd className="complex-parcel">
        <ComplexParcelDetail details={attributes.zoning} PIN={attributes.PIN} type={"zoning"} parcelArea={parcelArea} />
      </dd>
      <dt>Municipality</dt>
      <dd className="complex-parcel">
        <ComplexParcelDetail details={attributes.municipality} PIN={attributes.PIN} type={"municipality"} parcelArea={parcelArea} />
      </dd>
      <dt>Zip Code</dt>
      <dd className="complex-parcel">
        <ComplexParcelDetail details={attributes.zipcode} PIN={attributes.PIN} type={"zipcode"} parcelArea={parcelArea} />
      </dd>
      <dt>District</dt>
      <dd>{attributes.TaxDistrict}</dd>
      <dt>
        <abbr title="Legal Description">Legal Desc.</abbr>
      </dt>
      <dd>{attributes.LegalDescr}</dd>
      <dt>Square Footage</dt>
      <dd>{Number(attributes.Shape_Area).toFixed(2)}</dd>
      <dt>Acreage</dt>
      <dd>{attributes.Acreage}</dd>
      <dt>
        <abbr title="Council District">Dist.</abbr> Name
      </dt>
      <dd className="complex-parcel">
        <ComplexParcelDetail details={attributes.councilDistrict} PIN={attributes.PIN} type={"councilDistrict"} parcelArea={parcelArea} />
      </dd>
      <dt>
        <abbr title="Council District">Dist.</abbr> Population
      </dt>
      <dd>{attributes.councilDistrictPopulation || '-'}</dd>
      <dt>Owner Address</dt>
      <dd>
        {attributes.OwnerStreet}
        <br />
        {attributes.OwnerCity}, {attributes.OwnerState} {attributes.OwnerZip}
      </dd>
      <dt>Condo Label</dt>
      <dd>{attributes.CONDOLABEL}</dd>
      <dt>Lots</dt>
      <dd>{attributes.NumberOfLots}</dd>
      <dt>Deed Book</dt>
      <dd>{attributes.DeedBook}</dd>
      <dt>Deed Page</dt>
      <dd>{attributes.DeedPage}</dd>
      <dt>Date Sold</dt>
      <dd>{new Date(attributes.SaleDate).toDateString()}</dd>
      <dt>Soil Type</dt>
      <dd className="complex-parcel">
        <ComplexParcelDetail details={attributes.soilType} PIN={attributes.PIN} type={"soilType"} parcelArea={parcelArea} />
      </dd>
    </dl>
  );
};

export default ParcelDetails;